import { useEffect } from "react";

import { ProjectSelectedStore } from "@/stores/project-selected-store";
import { UserStore } from "@/stores/user-store";
import { useObservable } from "@/utils/hook";

import { syncSentryContext } from "./user-context";

export function useSentryContext(): void {
  const [user] = useObservable(UserStore.getInstance().observable);
  const [workspace] = useObservable(
    ProjectSelectedStore.getInstance().observable
  );

  useEffect(() => {
    syncSentryContext(user, workspace);
  }, [user, workspace]);
}
